import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-seeding-program",
  templateUrl: "./seeding-program.component.html",
  styleUrls: ["./seeding-program.component.scss"],
})
export class SeedingProgramComponent implements OnInit, OnChanges {
  @Input() formTabData: any; // Input property to receive formData from the parent component

  FormGroup: FormGroup[] = [];
  currentDate: string;
  dateFormat = "dd/MM/yyyy";
  constructor(private fb: FormBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formTabData && this.formTabData) {
      this.FormGroup = [];
      this.addFormGroup();

      try {
        if (this.formTabData.nhanDienThuongHieu) {
          const trimmedJsonString = this.formTabData.chuongTrinhCayGiong.trim();
          const seedingProgramData = JSON.parse(trimmedJsonString);

          if (
            seedingProgramData &&
            Array.isArray(seedingProgramData.seedingProgramForm)
          ) {
            this.FormGroup = seedingProgramData.seedingProgramForm.map(
              (item) => {
                const formGroup = this.createForm();
                this.setFormValues(formGroup, item);
                return formGroup;
              }
            );
            this.FormGroup.forEach((formGroup, index) => {
              this.setupAutoCalculations(index);
            });
          }
        }
      } catch (error) {
        console.error("Error parsing JSON data:", error);
        // Handle the error or provide appropriate fallback behavior
      }
    }
  }

  private setFormValues(formGroup: FormGroup, data: any): void {
    for (const controlName in data) {
      if (data.hasOwnProperty(controlName)) {
        const control = formGroup.get(controlName);
        if (control) {
          control.setValue(data[controlName]);
        }
      }
    }
  }

  addFormGroup(): void {
    const newForm = this.createForm();
    this.FormGroup.push(newForm);
    this.setupAutoCalculations(this.FormGroup.length - 1);
  }

  removeFormGroup(index: number): void {
    if (index >= 0 && index < this.FormGroup.length) {
      this.FormGroup.splice(index, 1);
    }
  }

  private createForm(): FormGroup {
    return this.fb.group({
      ngayGhiNhan: [new Date(), Validators.required],
      namThamGia: [null, Validators.required],
      soCayTrong: [null, Validators.required],
      soCayConSongSau6Thang: [null, Validators.required],
      tiLeCayConSongSau6Thang: [null, Validators.required],
      ghiChuSau6Thang: [null],
      soCayConSongSau1Nam: [null, Validators.required],  
      tiLeCayConSongSau1Nam: [null, Validators.required],
      ghiChuSau1Nam: [null],
      soCayConSongSau2Nam: [null, Validators.required],
      tiLeCayConSongSau2Nam: [null, Validators.required],
      daRaHoaDauTraiSau2Nam: [null],
      ghiChuSau2Nam: [null],
      soCayConSongSau3Nam: [null, Validators.required],
      tiLeCayConSongSau3Nam: [null, Validators.required],
      daRaHoaDauTraiSau3Nam: [null],
      ghiChuSau3Nam: [null],
    });
  }

  private serializeFormGroup(formGroup: FormGroup): any {
    const serialized = {};
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        serialized[controlName] = formGroup.get(controlName).value;
      }
    }
    return serialized;
  }

  submitForm() {
    const formData = {
      seedingProgramForm: this.FormGroup.map((formGroup) => {
        if (!formGroup.value.namThamGia || formGroup.value.namThamGia === '') {
          formGroup.get('ngayGhiNhan').setValue(null);
        }
        this.serializeFormGroup(formGroup);
          }
      ),
    };

    return formData;
  }

  setupAutoCalculations(index: number) {
    this.FormGroup[index]
      .get("soCayConSongSau6Thang")
      .valueChanges.subscribe(() => {
        this.calculateTiLeCayConSongSau6Thang(index);
      });

    this.FormGroup[index]
      .get("soCayConSongSau1Nam")
      .valueChanges.subscribe(() => {
        this.calculateTiLeCayConSongSau1Nam(index);
      });

    this.FormGroup[index]
      .get("soCayConSongSau2Nam")
      .valueChanges.subscribe(() => {
        this.calculateTiLeCayConSongSau2Nam(index);
      });

    this.FormGroup[index]
      .get("soCayConSongSau3Nam")
      .valueChanges.subscribe(() => {
        this.calculateTiLeCayConSongSau3Nam(index);
      });

    this.FormGroup[index].get("soCayTrong").valueChanges.subscribe(() => {
      this.calculateTiLeCayConSongSau6Thang(index);
      this.calculateTiLeCayConSongSau1Nam(index);
      this.calculateTiLeCayConSongSau2Nam(index);
      this.calculateTiLeCayConSongSau3Nam(index);
    });
  }

  calculateTiLeCayConSongSau6Thang(index: number) {
    const soCayConSongSau6Thang = this.FormGroup[index].get(
      "soCayConSongSau6Thang"
    ).value;
    const soCayTrong = this.FormGroup[index].get("soCayTrong").value;
    const tiLeCayConSongSau6Thang = soCayConSongSau6Thang / soCayTrong;
    this.FormGroup[index]
      .get("tiLeCayConSongSau6Thang")
      .setValue(tiLeCayConSongSau6Thang);
  }

  calculateTiLeCayConSongSau1Nam(index: number) {
    const soCayConSongSau1Nam = this.FormGroup[index].get(
      "soCayConSongSau1Nam"
    ).value;
    const soCayTrong = this.FormGroup[index].get("soCayTrong").value;
    const tiLeCayConSongSau1Nam = soCayConSongSau1Nam / soCayTrong;
    this.FormGroup[index]
      .get("tiLeCayConSongSau1Nam")
      .setValue(tiLeCayConSongSau1Nam);
  }

  calculateTiLeCayConSongSau2Nam(index: number) {
    const soCayConSongSau2Nam = this.FormGroup[index].get(
      "soCayConSongSau2Nam"
    ).value;
    const soCayTrong = this.FormGroup[index].get("soCayTrong").value;
    const tiLeCayConSongSau2Nam = soCayConSongSau2Nam / soCayTrong;
    this.FormGroup[index]
      .get("tiLeCayConSongSau2Nam")
      .setValue(tiLeCayConSongSau2Nam);
  }

  calculateTiLeCayConSongSau3Nam(index: number) {
    const soCayConSongSau3Nam = this.FormGroup[index].get(
      "soCayConSongSau3Nam"
    ).value;
    const soCayTrong = this.FormGroup[index].get("soCayTrong").value;
    const tiLeCayConSongSau3Nam = soCayConSongSau3Nam / soCayTrong;
    this.FormGroup[index]
      .get("tiLeCayConSongSau3Nam")
      .setValue(tiLeCayConSongSau3Nam);
  }

  ngOnInit() {
    this.addFormGroup();
    this.setupAutoCalculations(0);
  }

  getValidationStatus(controlName: string, yourForm: FormGroup): string {
    const control = yourForm.get(controlName);
    return  control.invalid ? 'error' : '';
  }
}
